import CryptoJS from "crypto-js";
import { previewUrl } from "./upload/useOss";
import HttpStudent from "./httpStudent.js";
import HttpTeacher from "./httpTeacher.js";
import HttpCompany from "./httpCompany.js";
import Http from "./http.js";

export const randomString = (length) => {
    let ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    ALPHABET += "abcdefghijklmnopqrstuvwxyz";
    ALPHABET += "0123456789";
    let str = "";
    for (let i = 0; i < length; i++) {
        let rand = Math.floor(Math.random() * ALPHABET.length);
        str += ALPHABET.substring(rand, rand + 1);
    }
    return str;
};

//防抖
export function debounce(callback) {
    let timer;
    return function (...args) {
        timer && window.clearTimeout(timer);
        timer = setTimeout(() => {
            callback && callback(...args);
        }, 900);
    };
}
export const decryptData = (str) => {
    let key, iv;
    key = iv = "yikejiaoyu_2016u";
    key = CryptoJS.enc.Utf8.parse(key);
    iv = CryptoJS.enc.Utf8.parse(iv);
    const decryptedData = CryptoJS.AES.decrypt(str, key, {
        iv,
        padding: CryptoJS.pad.Pkcs7,
    });
    const jsonString = decryptedData.toString(CryptoJS.enc.Utf8);
    return JSON.parse(jsonString);
};

export const endDate = () => {
    return Date.parse("2024-04-14 00:00:00");
};

// 获取文件icon图标
export const getFileIcon = (type) => {
    let fileSrc = "";

    if (["pdf"].includes(type)) fileSrc = "pdf-icon.png";
    if (["doc", "docx"].includes(type)) fileSrc = "word-icon.png";
    if (["ppt", "pptx"].includes(type)) fileSrc = "ppt-icon.png";
    if (["mp4"].includes(type)) fileSrc = "video-icon.png";
    if (["xls", "xlsx"].includes(type)) fileSrc = "excel-icon.png";
    if (["zip", "7z"].includes(type)) fileSrc = "zip-icon.png";

    return !fileSrc ? "" : require(`@/assets/img/task-center/${fileSrc}`);
};

// 计算文件尺寸
export const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 M";

    const k = 1024;
    const units = ["KB", "M", "G", "T", "P"];
    const mb = bytes / k;

    const i = Math.floor(Math.log(mb) / Math.log(k));
    const size = mb / Math.pow(k, i);
    return `${size.toFixed(2)} ${units[i]}`;
};

// 获得文件名单位
export const getFileUnit = (name) => {
    const nameArr = name?.split(".");

    if (!nameArr || nameArr.length.length === 0) return "";

    return nameArr[nameArr.length - 1].toLowerCase();
};

export const defaultDay = () => "2024-04-14";

// 普通下载文件
export const downloadFile = (url, name) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

// 下载文件
export const downloadFileByFetch = (url, name) => {
    const unit = getFileUnit(url);
    const filename = `${name ?? Date.now()}.${unit}`;

    return new Promise((resolve, reject) => {
        fetch(url)
            .then((res) => res.blob())
            .then((blob) => {
                const blobUrl = window.URL.createObjectURL(blob);
                downloadFile(blobUrl, filename);
                window.URL.revokeObjectURL(blobUrl);

                resolve({ blob });
            })
            .catch((error) => {
                reject(error);
            });
    });
};

// 预览文件的路径
export const previewFilePath = async (url, direct = false) => {
    // 直接则使用url，否则走oss
    const ossUrl = direct ? url : await previewUrl(url);

    const officeUrl = "http://view.officeapps.live.com/op/view.aspx?src=";
    const includeOfficeUnit = ["docx", "doc", "xlsx", "xls", "ppt", "pptx"];
    const unit = getFileUnit(url);

    return `${includeOfficeUnit.includes(unit) ? officeUrl : ""}${ossUrl}`;
};

// 判断数据是否为空，zero-数字类型是否需要判断0
export const isEmpty = (value, options = { zero: false }) => {
    if (value === null || value === undefined) return true;

    if (Array.isArray(value)) {
        return value.length === 0;
    }

    if (typeof value === "object") {
        return Object.keys(value).length === 0;
    }

    if (typeof value === "string") {
        return value.trim().length === 0;
    }

    if (typeof value === "number") {
        return !options?.zero ? !value : false;
    }

    return false;
};

// 请求方法
export const request = () => {
    const role = localStorage.getItem("role");

    const httpMap = {
        1: Http,
        2: Http,
        3: HttpTeacher,
        4: HttpStudent,
        5: HttpCompany,
    };

    return httpMap[Number(role)];
};
